import React from 'react';

const Mark = props => (
  <svg
    viewBox="0 0 20 20"
    height="22"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Group-4" fill="currentColor" fillRule="nonzero">
        <path
          d="M10.4896066,5.5018863 C9.61499133,5.5018863 8.67875683,5.84707955 8.06193611,6.7342702 L8.03741419,6.7342702 C8.03791498,6.41576646 7.91174076,6.11013631 7.68670131,5.88474303 C7.46166187,5.65934975 7.15623032,5.53269551 6.83772618,5.5326959 L6.8,5.5326959 L6.8,13.7261625 C6.79983325,14.0835792 6.94174255,14.4264049 7.19447431,14.6791367 C7.44720608,14.9318685 7.79003181,15.0737778 8.14744846,15.073611 L8.14744846,11.5261058 L8.17197039,11.5261058 C8.43039375,11.9574401 9.14530216,12.6842951 10.575119,12.6842951 C12.7311621,12.6842951 14.0251651,10.9099138 14.0251651,9.18457636 C14.0251651,7.3611512 12.8053566,5.5 10.4883491,5.5 M10.4393053,11.5135304 C9.14530216,11.5135304 8.12229777,10.4666329 8.12229777,9.08648866 C8.12229777,7.82895407 9.05916104,6.67076471 10.402208,6.67076471 C11.7949275,6.67076471 12.7437374,7.89120203 12.7437374,9.11101058 C12.7437374,10.552774 11.6471672,11.5135304 10.4393053,11.5135304"
          id="Shape"
          fill="currentColor"
        ></path>
        <path
          fill="#009DB1"
          d="M9.72050151,19.9961512 C4.33466233,19.8476561 0,15.4211106 0,10 C0,4.48542199 4.48542199,0 10,0 C15.514578,0 20,4.48542199 20,10 C20,15.4211106 15.6653377,19.8476561 10.2794985,19.9961512 L10,20 L9.72050151,19.9961512 Z M10,1.25 C5.17605984,1.25 1.25,5.17605984 1.25,10 C1.25,14.7346079 5.0319966,18.6042825 9.7329463,18.7459801 L10,18.75 L10.2670537,18.7459801 C14.8793062,18.606956 18.606956,14.8793062 18.7459801,10.2670537 L18.75,10 C18.75,5.17605984 14.8239402,1.25 10,1.25 Z"
          id="Path"
        ></path>
      </g>
    </g>
  </svg>
);

export default Mark;
